<template>
  <div class="main-wrapper">

    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox" style="padding-bottom: 0">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <!--									<img src="@/assets/img/easy-retail-logo.png" alt="" class="img-fluid">-->
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span class="font-weight-600 text-slate-300" style="color:#1f2937;">{{
                        $t("logo.prefix")
                      }} </span><span class="font-weight-bold text-slate-500"
                                      style="color: #fff; font-weight: bold; background-color: #2E3B4E; padding: 6px; border-radius: 5px">{{
                      $t("logo.suffix")
                    }}</span>
                    <!--/*                    <span class="font-weight-600 text-slate-300" style="color:#1f2937;">FASTA </span><span class="font-weight-bold text-slate-500" style="color: #fff; font-weight: bold; background-color: #36385C; padding: 6px; border-radius: 5px">TEXT</span>*/-->
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted">Login to your portal</h6>
              <div class="mt-4">
                <div v-if="success === true && message" class="alert alert-success" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <!--                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">-->
                  <!--                    <span aria-hidden="true" @click="resetMessage">×</span>-->
                  <!--                  </button>-->
                </div>
                <div v-if="success === false && message" class="alert alert-danger" role="alert">
                  {{ message }}
                  <!--                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">-->
                  <!--                    <span aria-hidden="true" @click="resetMessage">×</span>-->
                  <!--                  </button>-->
                </div>
              </div>
            </div>
            <form class="vld-parent" ref="formContainer">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="user.username"
                  required
                  v-model="user.username"
                  name="user.username"
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group mb-4">
                <input
                  type="password"
                  class="form-control"
                  id="user.password"
                  required
                  v-model="user.password"
                  name="user.password"
                  placeholder="Enter your password"
                  autocomplete="off"
                />
              </div>
              <div class="text-center">
                <button class="btn btn-primary btn-block account-btn" type="button" @click="login()">Login</button>
                <button class="btn btn-primary btn-block account-btn" type="button" @click="register()"
                        style="background-color: white; color: black">Sign Up
                </button>
              </div>
            </form>

            <!--								<div class="text-center forgotpass mt-4"><router-link to="/forgot-password">Forgot Password?</router-link></div>-->
            <!--								<div class="login-or">-->
            <!--									<span class="or-line"></span>-->
            <!--									<span class="span-or">or</span>-->
            <!--								</div>-->

            <!--								&lt;!&ndash; Social Login &ndash;&gt;-->
            <!--								<div class="social-login">-->
            <!--									<span>Login with</span>-->
            <!--									<a href="#" class="facebook"><i class="fab fa-facebook-f"></i></a><a href="#" class="google"><i class="fab fa-google"></i></a>-->
            <!--								</div>-->
            <!--								&lt;!&ndash; /Social Login &ndash;&gt;-->

            <div class="text-center dont-have mb-4">
              <!--                  Don’t have an account?-->
              <!--                  <router-link to="/register">Register store</router-link>-->
              <div>
                <small id="terms-footnote" class="footnote">
                  By continuing, you confirm you have read and agree to the <a href="https://salesdue.com/privacy">privacy
                  policy</a> and <a href="https://salesdue.com">terms and conditions</a> that govern your usage of our
                  services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import authServiceApi from "../../service/AuthServiceApi";
import {allowedModules} from "../../utils/modules";

export default {
  name: "login",
  data() {
    return {
      success: null,
      message: "",
      user: {
        username: null,
        password: null
      },
      loading: false,
      token: null,
      fullPage: false,
    };
  },
  // computed: {
  //   resetMessage(e){
  //     this.message = ""
  //   },
  //   loggedIn() {
  //     return this.$store.state.auth.status.loggedIn;
  //   }
  // },
  // created() {
  //   if (this.loggedIn) {
  //     this.$router.push('/dashboard/sales');
  //   }
  // },
  methods: {
    register() {
      this.$router.push('/register');
    },
    login() {
      if (!this.user.username) {
        this.fireNotification("warning", 'Bad Request!', "Username is required")
        return
      }
      if (!this.user.password) {
        this.fireNotification("warning", 'Bad Request!', "Password is required")
        return
      }
      let data = {
        username: this.user.username,
        password: this.user.password,
        domain: location.host
      };
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      authServiceApi.login(data)
        .then(response => {
          let success = response.data.success;
          if (success) {
            const modules = allowedModules.filter(module => module.domains.some(value => value === location.host));
            if (!modules.length) {
              this.success = false
              this.message = "Not authorised, domain not allowed"
              return;
            }

            this.$i18n.locale = modules[0].name

            const permissions = response.data.data.permissions

            const profile = allowedModules.filter(module => module.name === this.$i18n.locale)[0]
            if (permissions.some(value => value === profile.dashBoardPermission)) {
              //localStorage.setItem("homeUrl", profile.dashboardUrl)
              localStorage.setItem("homeUrl", "/dashboard")
            }

            // if (permissions.some(value => value === 'DASHBOARD_READ') && modules.some(value => value.modules.some(value1 => value1 === 'orders'))){
            //   localStorage.setItem("homeUrl", "/dashboard/sales")
            // } else if (permissions.some(value => value === 'DASHBOARD_READ') && modules.some(value => value.modules.some(value1 => value1 === 'invoices'))){
            //   localStorage.setItem("homeUrl", "/dashboard/invoices")
            // } else {
            //     for (let i = 0; i < permissions.length; i++){
            //       const url = this.determineHomeUrl(permissions[i]);
            //       if (url.length){
            //         localStorage.setItem("homeUrl", url)
            //         break
            //       }
            //     }
            // }

            if (!localStorage.getItem("homeUrl")) {
              this.success = false
              this.message = "Not authorised"
              return
            }
            this.success = true
            this.message = response.data.narrative
            this.$store.dispatch('auth/setLoginSuccess', this.user)
            let mid = response.data.data.mid
            if (!mid) {
              this.$router.push('/settings/general');
            }
            localStorage.setItem('mid', mid);
            localStorage.setItem('user', JSON.stringify(response.data.data));
            if (!response.data.data.permissions) {
              alert('No permissions found!')
              return
            }
            localStorage.setItem('permissions', JSON.stringify(response.data.data.permissions));
            this.$router.push(localStorage.getItem("homeUrl"))
          } else {
            this.success = false
            this.message = response.data.narrative
          }
        })
        .catch(e => {
          console.log(">>> Error: ", e)
          if (e.response && e.response.status) {
            if (e.response.status === 400 || e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              this.success = false
              this.message = e.response.data.narrative
              return
            }
          }
          this.success = false
          this.message = "An error occurred"
        }).finally(() => {
        loader.hide()
      })
    },
    determineHomeUrl(permission) {
      switch (permission) {
        case "DASHBOARD_READ":
          return "/dashboard/sales"
        case "PRODUCTS_READ":
          return "/products"
        case "INVOICES_READ":
          return "/invoices"
        case "CUSTOMERS_READ":
          return "/customers"
        case "SETTINGS_READ":
          return "/settings/general"
        case "INTEGRATIONS_READ":
          return "/integrations"
        default:
          return "";
      }
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Need help?</a>'
      })
    },
  },
  mounted() {
    // if (this.$store.state.app.verificationMessage && this.$store.state.app.verificationMessage.success){
    //   this.success = this.$store.state.app.verificationMessage.success;
    //   this.message = this.$store.state.app.verificationMessage.message;
    //   this.$store.dispatch('app/clearVerificationMessage')
    // }
    alert('Login mounted')
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/SignIn.vue